import { AuthenticationService } from '@/core/services/authentication.service';
import { Component } from '@angular/core';

@Component({
  selector: 'cosmos-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {

  public constructor(
    private readonly _authenticationService: AuthenticationService,
  ) { }

  public logout(): void {
    this._authenticationService.logout();
  }
}
